import { eThongKeSiSoActionDefine } from "../../action-types/thong-ke/IThongKeSiSoActions";
import { generateActions } from "../generateActions";

export const thongKeSiSoActions = {
    ...generateActions(eThongKeSiSoActionDefine, "THONG_KE_SI_SO"),
}